import React from 'react';
import { useSelector } from 'react-redux';
import omit from 'lodash/omit';
import last from 'lodash/last';
import { getOrganizationDomain } from 'Shared/selectors/organization';

import CreateTeammateField from './CreateTeammateField/CreateTeammateField';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  formValues: Array<{
    fullName: string;
    email: string;
    recurringMeetingId: number;
    errorMessage: string;
  }>;
  isSuggestedListOpened: boolean;
  onSetIsSuggestedListOpened: Function;
  onSetFormValues: Function;
};

const emptyFormValueTemplate = domain => ({
  fullName: '',
  email: domain,
  recurringMeetingId: null,
  errorMessage: null,
  fromCalendar: false,
});

function CreateNameSection({ formValues, isSuggestedListOpened, onSetFormValues, onSetIsSuggestedListOpened }: Props) {
  const organizationDomain = useSelector(getOrganizationDomain);

  const handleTextInputChange = (event, key) => {
    onSetIsSuggestedListOpened(true);
    onSetFormValues({ ...formValues, [key]: { ...formValues[key], [event.target.name]: event.target.value } });
  };

  const handleNewItemAddClick = () => {
    const lastKey = last(Object.keys(formValues));
    const newKey = parseInt(lastKey, 10) + 1;
    onSetFormValues({ ...formValues, [newKey]: emptyFormValueTemplate(organizationDomain) });
  };

  const handleRemoveItem = key => onSetFormValues(omit(formValues, [key]));

  const handleRemoveRecurringMeetingId = key => {
    onSetFormValues({ ...formValues, [key]: { ...formValues[key], recurringMeetingId: null } });
  };

  const handleSuggestionClick = ({ identif, fullName, email, recurringMeetingId }) => {
    onSetFormValues({
      ...formValues,
      [identif]: {
        ...formValues[identif],
        fullName,
        email,
        recurringMeetingId,
      },
    });
  };

  return (
    <div className="create-name-section">
      <div className="mt-3">
        {Object.entries(formValues).map((formValue, index) => {
          return (
            <CreateTeammateField
              formValues={formValues}
              key={formValue[0]}
              index={index}
              isSuggestedListOpened={isSuggestedListOpened}
              valuesCount={formValues.length}
              identif={formValue[0]}
              formValue={formValue[1]}
              onTextChange={handleTextInputChange}
              onRemoveItem={handleRemoveItem}
              onRemoveRecurringMeetingId={handleRemoveRecurringMeetingId}
              onSuggestionClick={handleSuggestionClick}
              onSetIsSuggestedListOpened={onSetIsSuggestedListOpened}
            />
          );
        })}
      </div>
      <button
        type="button"
        onClick={handleNewItemAddClick}
        className="bulk-invite-temmates-modal-button btn btn-link text-decoration-none p-0 mb-3"
      >
        <span className="mr-1">
          <WpIcon name="plus-circle" />
        </span>
        Add another
      </button>
    </div>
  );
}

export default CreateNameSection;
